export enum ValidationResultEnum {
    Success,
    Failure
}
